/**
 * User: Shad
 * Date: 9/27/13
 */
"use strict";
var PaymentMethod = require('bunsen/models/ecomm/PaymentMethodModel');
var WireTransfer = PaymentMethod.extend();

module.exports = WireTransfer;

var ends = require('dibs-endpoints');
var SoaModel = require('bunsen/models/SoaModel');
var _ = require('underscore');

_.extend(WireTransfer.prototype, {
    constructor : function () {
        SoaModel.prototype.constructor.apply(this, arguments);
    },
    url: function () {
        return ends.paymentMethod();
    },
    getDisplayVal: function () {
        return 'Wire Transfer';
    },
    getNumber: function () {
        return this.getNumberType() ? this.get(this.getNumberType()) : null;
    },
    getNumberType: function () {
        if (this.get('confirmationNumber')) {
            return 'confirmationNumber';
        }
        if (this.get('transactionNumber')) {
            return 'transactionNumber';
        }
        if (this.get('referenceNumber')) {
            return 'referenceNumber';
        }
        return null;
    },
    getName: function () {
        return this.get('accountHolderName');
    },
    defaults : function () {
        return {
            apiType : 'wireTransfer',
            paymentMethodType : 'WIRE_TRANSFER'
        };
    }
});



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/models/ecomm/payment-methods/WireTransfer.js
// module id = 191
// module chunks = 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38 39 40 41 42 43 44 45 46 47 48 49 50 51 52 53 54 55 56